import React, { useState, useEffect } from "react";
import { array, func, bool, number, object, string } from "prop-types";
import { connect } from "react-redux";
import { get } from "lodash";

import More from "../../atoms/More";
import Checkbox from "../../atoms/Checkbox";
import RadioButton from "../../atoms/RadioButton";
import Button from "../../atoms/Button";
import CustomStoryCard9 from "../../molecules/CustomStoryCard9";
import LabelWithArrow from "../../atoms/LabelWithArrow";
import { CloseIcon } from "../../basic/icons/close-icon";
import DfpAd from "../../dfp-ad";

import { toBanglaNum } from "../../utils/utils";
import { setLoading, setAuthors } from "../../helper/actions";
import { getAllAuthors } from "../../helper/api";
import { storyTemplatesList, sortingList } from "../../utils/constant";
import { staticTexts } from "../../utils/Translate";

import "./searchStories1AdWithLoadMore.m.css";

const SearchStories1AdWithLoadMore = ({
  total,
  list,
  onLoadMore,
  isMoreStories,
  setLoading,
  isBorderTop = false,
  isNotification = false,
  authorList,
  setAuthors,
  sectionList,
  getStories,
  publisherAttributes,
  showButtonSpinner,
  domainSlug,
  domains,
}) => {
  const [firstTime, setFirstTime] = useState(true);
  const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [authorInfo, setAuthorInfo] = useState({ isOpen: false, showMore: false });
  const [authorIdList, setAuthorIdList] = useState([]);
  const [sectionInfo, setSectionInfo] = useState({ isOpen: false, showMore: false });
  const [isStoryTemplateViewOpen, setIsStoryTemplateViewOpen] = useState(false);
  const [storyTemplate, setStoryTemplate] = useState("all");
  const [isSortViewOpen, setIsSortViewOpen] = useState(false);
  const [sortType, setSortType] = useState("default");
  const [isDateViewOpen, setIsDateViewOpen] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [sectionsSelected, setSectionsSelected] = useState([]);
  const [DatePicker, setDatePicker] = useState(null);

  const { lang } = publisherAttributes;
  const storyList = [...list]; // Make a copy of it to avoid changing of list
  const firstSetStories = storyList.splice(0, 4); // Before Advertisement
  const remainingStories = storyList.splice(0, storyList.length); // After Advertisement
  const subSections = sectionList.filter((item) => item["parent-id"] !== null);
  let parentSections = [];

  if (domainSlug) {
    const currentDomain = domains.find((item) => item.slug === domainSlug);
    parentSections = sectionList.filter((item) => item["parent-id"] === currentDomain["section-ids"][0]);
  } else {
    parentSections = sectionList.filter((item) => item["parent-id"] === null && item["domain-slug"] === null);
  }

  useEffect(() => {
    global.deviceWidth < 876 && setIsMobile(true);

    // Fetch authors only if authors not there
    if (!(authorList && authorList.length)) {
      setLoading(true);

      getAllAuthors()
        .then((results) => setAuthors(results))
        .finally(() => setLoading(false));
    }
  }, []);

  useEffect(() => {
    // If mobile filter view is opened then don't make api call to refresh the stories
    if (!isMobileFilterOpen) {
      getStoryList();
    }
  }, [authorIdList, sectionsSelected, storyTemplate, sortType, fromDate, toDate]);

  const getUriFromPath = () => {
    try {
      const search = window.location.search.substring(1);
      const pa = JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) {
        return key === "" ? value : decodeURIComponent(value);
      });
      return pa;
    } catch (error) {
      return {};
    }
  };

  useEffect(() => {
    searchQueryAdded();
  }, []);
  const getStoryList = () => {
    const params = {};

    if (authorIdList && authorIdList.length) {
      params["author-id"] = authorIdList.join();
    }

    if (sectionsSelected && sectionsSelected.length) {
      const sectionIdList = [];
      let tempObj = null;

      sectionsSelected.forEach((section) => {
        if (section.isSectionSelected) {
          // Fetch the section
          tempObj = parentSections.find((item) => item.id === section.sectionId);
          sectionIdList.push(tempObj.id);
        }

        if (section.subSectionList && section.subSectionList.length) {
          section.subSectionList.forEach((id) => {
            tempObj = subSections.find((item) => item.id === id);
            sectionIdList.push(tempObj.id);
          });
          ``;
        }
      });

      if (sectionIdList.length) {
        params["section-id"] = sectionIdList.join();
      }
    }

    if (storyTemplate && storyTemplate !== "all") {
      params.type = storyTemplate;
    }

    if (sortType && sortType !== "default") {
      params.sort = sortType;
    }

    if (fromDate) {
      params["published-after"] = fromDate.valueOf();
    }

    if (toDate) {
      params["published-before"] = toDate.valueOf();
    }
    // Fetch stories only if there are any params
    if (Object.keys(params).length) {
      getStories(
        params,
        parentSections.map((item) => item.id)
      );
    } else {
      !firstTime &&
        getStories(
          {},
          parentSections.map((item) => item.id)
        ); // This will load the stories based on search text
    }
  };

  const searchQueryAdded = () => {
    const pathObj = getUriFromPath();

    Object.keys(pathObj).map((key) => {
      if (pathObj[key] && key === "author-id") {
        const idList = [];
        const v = pathObj[key];
        idList.push(...v.split(",").map(Number));
        setAuthorIdList(idList);
      } else if (pathObj[key] && key === "section-id") {
        const list = [];
        const v = pathObj[key];
        for (const id of v.split(",")) {
          const sectionId = Number(id);
          const sub = subSections.find((item) => item.id === sectionId);
          const parent = sub && parentSections.find((item) => item.id === sub["parent-id"]);

          if (parent) {
            const subExists = list.find((item) => item.sectionId === parent.id);
            if (subExists) {
              const index = list.findIndex((item) => item.sectionId === parent.id);
              list[index].subSectionList.push(sectionId);
            } else {
              list.push({
                sectionId: parent.id,
                isSectionSelected: false,
                subSectionList: [sectionId],
              });
            }
          } else {
            list.push({
              sectionId: sectionId,
              isSectionSelected: true,
              subSectionList: [],
            });
          }
        }
        setSectionsSelected(list);
      } else if (pathObj[key] && key === "type") {
        setStoryTemplate(pathObj[key]);
      } else if (pathObj[key] && key === "sort") {
        setSortType(pathObj[key]);
      } else if (pathObj[key] && key === "published-after") {
        setFromDate(new Date(+pathObj[key]));
      } else if (pathObj[key] && key === "published-before") {
        setToDate(new Date(+pathObj[key]));
      }
    });
  };

  const clearFilters = () => {
    if (authorIdList && authorIdList.length) {
      setAuthorIdList([]);
    }

    if (sectionsSelected && sectionsSelected.length) {
      setSectionsSelected([]);
    }

    if (storyTemplate !== "all") {
      setStoryTemplate("all");
    }

    if (sortType !== "default") {
      setSortType("default");
    }

    if (fromDate) {
      setFromDate(null);
    }

    if (toDate) {
      setToDate(null);
    }

    setIsStoryTemplateViewOpen(false);
    setIsSortViewOpen(false);
    setIsDateViewOpen(false);
    setAuthorInfo({ isOpen: false, showMore: false });
    setSectionInfo({ isOpen: false, showMore: false });
    firstTime && setFirstTime(false);
  };

  const mobileFilterOpenCloseClick = () => setIsMobileFilterOpen(!isMobileFilterOpen);

  const searchBtnClick = () => {
    setIsMobileFilterOpen(false);
    getStoryList();
  };

  const authorLabelClick = () => {
    const authorObj = { ...authorInfo };
    authorObj.isOpen = !authorInfo.isOpen;

    setAuthorInfo(authorObj);
  };

  const authorChange = (e, authorId) => {
    let idList = null;

    if (e.target.checked) {
      idList = [...authorIdList];
      idList.push(authorId);
    } else {
      idList = authorIdList.filter((name) => name !== authorId);
    }

    firstTime && setFirstTime(false);
    setAuthorIdList(idList);
  };

  const sectionLabelClick = () => {
    const sectionObj = { ...sectionInfo };
    sectionObj.isOpen = !sectionInfo.isOpen;

    setSectionInfo(sectionObj);
  };

  const sectionChange = (sectionId) => (e) => {
    const list = [...sectionsSelected];

    if (e.target.checked) {
      const sectionObj = list.find((item) => item.sectionId === sectionId);
      const subSectionIdList = getSubSection(sectionId).map((item) => item.id);

      if (sectionObj) {
        // If parent is checked then set to true and include all subsections
        sectionObj.isSectionSelected = true;
        sectionObj.subSectionList = subSectionIdList;

        const index = list.findIndex((item) => item.sectionId === sectionId);
        list[index] = sectionObj; // Update the object in the respective position
      } else {
        // Create if section doesn't exists and get subsection id list into it
        list.push({
          sectionId: sectionId,
          isSectionSelected: true,
          subSectionList: subSectionIdList,
        });
      }
    } else {
      // Search for the section id
      const index = list.indexOf(list.find((item) => item.sectionId === sectionId));

      list.splice(index, 1); // Remove the section from the list which is unchecked
    }

    firstTime && setFirstTime(false);
    setSectionsSelected(list);
  };

  const subSectionChange = (sectionId, subSectionId) => (e) => {
    const list = [...sectionsSelected];
    const sectionObj = list.find((item) => item.sectionId === sectionId);
    const subSectionIdList = sectionObj && sectionObj.subSectionList ? sectionObj.subSectionList : [];

    if (e.target.checked) {
      if (sectionObj) {
        // If section already exists then just add the subsectionId into it
        subSectionIdList.push(subSectionId);
        sectionObj.subSectionList = subSectionIdList;

        const index = list.findIndex((item) => item.sectionId === sectionId);
        list[index] = sectionObj;
      } else {
        // If section doesn't exist then create it and set the value as false so that parent is not checked by default
        list.push({
          sectionId: sectionId,
          isSectionSelected: false, // Child is clicked so make this as false
          subSectionList: [subSectionId],
        });
      }
    } else {
      // Remove the specific subsection id
      sectionObj.subSectionList = subSectionIdList.filter((item) => item !== subSectionId);

      const index = list.findIndex((item) => item.sectionId === sectionId);
      list[index] = sectionObj;
    }

    firstTime && setFirstTime(false);
    setSectionsSelected(list);
  };

  const storyTemplateLabelClick = () => setIsStoryTemplateViewOpen(!isStoryTemplateViewOpen);

  const storyTemplateClick = (value) => {
    firstTime && setFirstTime(false);
    setStoryTemplate(value);
  };

  const sortTypeLabelClick = () => setIsSortViewOpen(!isSortViewOpen);

  const sortTypeClick = (value) => {
    firstTime && setFirstTime(false);
    setSortType(value);
  };

  const dateLabelClick = async () => {
    setIsDateViewOpen(!isDateViewOpen);
    const datePickerImport = await import(/* webpackChunkName: "react-date-picker" */ "../../atoms/ReactDatePicker");
    setDatePicker(datePickerImport.default);
  };

  const dateSelected = (newDate, type) => {
    firstTime && setFirstTime(false);
    type === "from" ? setFromDate(newDate) : setToDate(newDate);
  };

  const gitFilterCountView = () => {
    let count = 0;

    if (authorIdList && authorIdList.length) {
      count++;
    }

    if (sectionsSelected && sectionsSelected.length) {
      count++;
    }

    if (storyTemplate && storyTemplate !== "all") {
      count++;
    }

    if (sortType && sortType !== "default") {
      count++;
    }

    if (fromDate || toDate) {
      count++;
    }

    if (count) {
      return <span styleName="filter-count">{count}</span>;
    }

    return null;
  };

  const loadMoreListener = () => {
    onLoadMore(parentSections.map((item) => item.id));
  };

  const MoreComponent = (
    <div styleName={`load-more-view ${lang}-load-more-view`}>
      <More
        type="load-more"
        text={staticTexts(lang).more}
        onClick={loadMoreListener}
        showButtonSpinner={showButtonSpinner}
      />
    </div>
  );

  const getAuthorsView = () => {
    const publicAuthorsList = authorList.filter((author) =>
      author.metadata["Public Author"] ? author.metadata["Public Author"].toLowerCase() === "yes" : null
    );
    const publicAuthorsNameList =
      publicAuthorsList.length > 0 &&
      publicAuthorsList.map((author) => {
        return {
          authorName: author.name,
          authorId: author.id,
        };
      });
    const publicAuthorsNameSortedList =
      publicAuthorsNameList &&
      publicAuthorsNameList.sort((x, y) => x.authorName.toLowerCase().localeCompare(y.authorName.toLowerCase()));
    return (
      <React.Fragment>
        <ul styleName="list-view">
          {publicAuthorsNameList &&
            publicAuthorsNameList.length > 0 &&
            publicAuthorsNameSortedList.map((author, index) => (
              <li key={index} styleName="list-item">
                <Checkbox
                  text={author.authorName}
                  isChecked={authorIdList.includes(author.authorId)}
                  onChange={(e) => authorChange(e, author.authorId)}
                />
              </li>
            ))}
        </ul>
      </React.Fragment>
    );
  };

  const getSubSection = (sectionId) =>
    (
      sectionId &&
      subSections.length > 0 &&
      subSections.filter((item) => item["parent-id"] === sectionId)
    ).sort((x, y) => x.name.toLowerCase().localeCompare(y.name.toLowerCase())) || [];

  const getSectionView = () => {
    const sortedParentSections = parentSections.sort((x, y) =>
      x.name.toLowerCase().localeCompare(y.name.toLowerCase())
    );

    return (
      <React.Fragment>
        {sortedParentSections && sortedParentSections.length > 0 && (
          <ul styleName="list-view">
            {sortedParentSections.map((section, index) => (
              <li key={index} styleName="list-item">
                <Checkbox
                  text={section["display-name"] || section.name}
                  isChecked={!!sectionsSelected.find((item) => item.sectionId === section.id && item.isSectionSelected)}
                  onChange={sectionChange(section.id)}
                />
                {getSubSection && getSubSection(section.id).length > 0 && (
                  <ul>
                    {getSubSection &&
                      getSubSection(section.id).length > 0 &&
                      getSubSection(section.id).map((subsection, index) => {
                        const obj = sectionsSelected.find((item) => item.sectionId === section.id);
                        const subSectionIdList = obj && obj.subSectionList ? obj.subSectionList : [];

                        return (
                          <li key={index} styleName="list-item-subsection">
                            <Checkbox
                              text={subsection["display-name"] || subsection.name}
                              isChecked={subSectionIdList.includes(subsection.id)}
                              onChange={subSectionChange(section.id, subsection.id)}
                            />
                          </li>
                        );
                      })}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        )}
      </React.Fragment>
    );
  };

  const getStoriesView = () => (
    <div styleName="stories">
      {firstSetStories.map((story, index) => (
        <CustomStoryCard9
          story={story}
          key={index}
          className={`${isBorderTop && "border-line-top"}`}
          aspectRatio={isMobile ? [4, 3] : [3, 2]}
          imageType={isMobile ? "image4x3" : "image3x2"}
          isNotification={isNotification}
          isAuthor={true}
        />
      ))}

      <div styleName="ad-wrapper">
        <div styleName="ad-slot">
          <DfpAd
            adtype={lang === "en" ? "EnPalo_ROS_336x280_R3" : "News_336x280_R3"}
            slotId="SearchStories1AdWithLoadMore-firstAd-1"
          />
        </div>
      </div>

      {remainingStories.map((story, index) => (
        <React.Fragment key={index}>
          {index % 6 === 0 && index >= 6 && (
            <div styleName="ad-wrapper">
              <div styleName="ad-slot">
                <DfpAd
                  adtype={lang === "en" ? "EnPalo_ROS_336x280_R3" : "News_336x280_R3"}
                  slotId={`SearchStories1AdWithLoadMore-secondAd-${index / 6 + 1}`}
                />
              </div>
            </div>
          )}
          <CustomStoryCard9
            story={story}
            aspectRatio={isMobile ? [4, 3] : [3, 2]}
            imageType={isMobile ? "image4x3" : "image3x2"}
            isNotification={isNotification}
            isAuthor={true}
          />
        </React.Fragment>
      ))}

      {isMoreStories ? MoreComponent : null}
    </div>
  );

  const getStoryTemplatesView = () => (
    <ul styleName="list-view-no-height">
      {storyTemplatesList.map((item, index) => (
        <li key={index} styleName="list-item">
          <RadioButton
            title={item[`${lang}Label`]}
            value={item.key}
            isChecked={storyTemplate === item.key}
            onClick={() => storyTemplateClick(item.key)}
          />
        </li>
      ))}
    </ul>
  );

  const getSortingView = () => (
    <ul styleName="list-view-no-height">
      {sortingList.map((item, index) => (
        <li key={index} styleName="list-item">
          <RadioButton
            title={item[`${lang}Label`]}
            value={item.key}
            name="sort_radio"
            isChecked={sortType === item.key}
            onClick={() => sortTypeClick(item.key)}
          />
        </li>
      ))}
    </ul>
  );

  const getDateView = () => {
    return (
      <div>
        <DatePicker
          fromDate={fromDate}
          toDate={toDate}
          onDateSelect={dateSelected}
          startPlaceholder={staticTexts(lang).fromTheDate}
          endPlaceholder={staticTexts(lang).upToNow}
          lang={lang}
        />
      </div>
    );
  };

  const filterView = () => (
    <React.Fragment>
      {/* Total Records with Clear Filter */}
      {!isMobile && (
        <div styleName={`count-with-filter ${lang === "en" ? "en-count-with-filter" : ""}`}>
          {getTotalResultsText()}
          {clearFilterText()}
        </div>
      )}

      {/* Authors View */}
      <div styleName={`authors-view ${lang === "en" ? "en-authors-view" : ""}`}>
        <LabelWithArrow label={staticTexts(lang).author} isOpen={authorInfo.isOpen} onClick={authorLabelClick} />
        {authorInfo.isOpen ? getAuthorsView() : null}
      </div>

      {/* Sections View */}
      <div styleName={`sections-view ${lang === "en" ? "en-sections-view" : ""}`}>
        <LabelWithArrow label={staticTexts(lang).sekasana} isOpen={sectionInfo.isOpen} onClick={sectionLabelClick} />
        {sectionInfo.isOpen ? getSectionView() : null}
      </div>

      {/* Story Templates View */}
      <div styleName={`sections-view ${lang === "en" ? "en-sections-view" : ""}`}>
        <LabelWithArrow
          label={staticTexts(lang).storyTypes}
          isOpen={isStoryTemplateViewOpen}
          onClick={storyTemplateLabelClick}
        />
        {isStoryTemplateViewOpen ? getStoryTemplatesView() : null}
      </div>

      {/* Sort View View */}
      <div styleName={`sections-view ${lang === "en" ? "en-sections-view" : ""}`}>
        <LabelWithArrow label={staticTexts(lang).sortOder} isOpen={isSortViewOpen} onClick={sortTypeLabelClick} />
        {isSortViewOpen ? getSortingView() : null}
      </div>

      {/* Date View */}
      <div styleName={lang === "en" ? "en-sections-view" : ""}>
        <LabelWithArrow label={staticTexts(lang).date} isOpen={isDateViewOpen} onClick={dateLabelClick} />
        {isDateViewOpen && DatePicker ? getDateView() : null}
      </div>

      <Button content={staticTexts(lang).advanceSearchBox} buttonType="type3" onClick={searchBtnClick} />
    </React.Fragment>
  );

  const mobileFilterButtonView = () => (
    <div styleName={`mobile-filter-wrapper ${isMobileFilterOpen ? "open" : ""}`}>
      {getTotalResultsText()}
      <button styleName="mobile-filter-button" onClick={mobileFilterOpenCloseClick}>
        <span styleName="filter-label">{staticTexts(lang).filterText}</span>
        {!isMobileFilterOpen && gitFilterCountView()}
      </button>
    </div>
  );

  const clearFilterText = () => (
    <div styleName="clear-filter" onClick={clearFilters}>
      {gitFilterCountView() ? (
        <>
          {staticTexts(lang).filterClearText}
          {gitFilterCountView()}
        </>
      ) : null}
    </div>
  );

  const getTotalResultsText = () => (
    <div styleName="label">
      <span styleName="label-result-text">{staticTexts(lang).resultsObtained}:</span>
      <span>{lang === "bn" ? toBanglaNum(total) : total}</span>
    </div>
  );

  const mobileFilterOverlay = () => (
    <div styleName="mobile-filter-overlay">
      <div styleName="mobile-close-wrapper">
        {clearFilterText()}
        <div styleName="close-icon" onClick={mobileFilterOpenCloseClick}>
          <CloseIcon width={24} height={24} color="#000" />
        </div>
      </div>

      <div styleName="mobile-filter-view">{filterView()}</div>
    </div>
  );

  return (
    <div styleName="wrapper">
      <div styleName="desktop-filter-view">{filterView()}</div>

      {mobileFilterButtonView()}

      {isMobileFilterOpen ? mobileFilterOverlay() : null}

      {firstSetStories && firstSetStories.length ? (
        getStoriesView()
      ) : (
        <div styleName={`no-stories ${lang === "en" ? "en-no-stories" : ""}`}>
          {staticTexts(publisherAttributes.lang).noResultsFound}
        </div>
      )}
      <div>
        <DfpAd
          adtype={publisherAttributes.lang === "en" ? "EnPalo_ROS_300x250_R2" : "News_336x280_R2"}
          slotId="SearchStories1AdWithLoadMore-sideAd"
        />
      </div>
    </div>
  );
};

SearchStories1AdWithLoadMore.propTypes = {
  list: array,
  onLoadMore: func,
  setLoading: func,
  loading: bool,
  isMoreStories: bool,
  isBorderTop: bool,
  isNotification: bool,
  total: number.isRequired,
  setAuthors: func,
  authorList: array,
  sectionList: array,
  getStories: func,
  publisherAttributes: object,
  showButtonSpinner: bool,
  domainSlug: string,
  domains: array,
};

const mapStateToProps = (state) => ({
  sectionList: get(state, ["qt", "config", "sections"], []),
  authorList: get(state, ["authorReducer"], []),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
  domains: get(state, ["qt", "config", "domains"], []),
});

SearchStories1AdWithLoadMore.storyLimit = 10;

const mapDispatchToProps = (dispatch) => ({
  setLoading: (isLoading) => dispatch(setLoading(isLoading)),
  setAuthors: (list) => dispatch(setAuthors(list)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchStories1AdWithLoadMore);
